import React, { FC } from 'react';

import Button from '../../../../../components/Button';

interface IProps {
  onSave: () => Promise<void>;
  onWithdrawToggle: () => void;
}

const HoleScoresButtons: FC<IProps> = props => {
  const { onWithdrawToggle, onSave } = props;

  return (
    <>
      <Button variant="contained" color="primary" className="save-scorer-button" onClick={onSave}>
        {'SAVE'}
      </Button>

      <Button color="primary" className="save-scorer-button second" onClick={onWithdrawToggle}>
        WITHDRAW A PLAYER
      </Button>
    </>
  );
};

export default HoleScoresButtons;
